// Compass (#191) — gate predicate for the header "🧭 Compass" data-browser
// button. Compass is the in-app MongoDB-Compass-style data browser for the
// Convex mirror AND the live Mongo collections (read-only in Phase 1).
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"compass"` token.
//
// Access source (#202): Compass/Dashboard/Time-Machine access is managed in ONE
// place — the "Tab Access" section of UserDetailModal, which reads/writes
// `Users.screenAccessList` (the same array that gates the Optimizer/Scheduler/
// Jobs tabs). This replaced the legacy standalone boolean `Users.compassAccess`;
// a one-time backfill (dbtools/src/mutations/access-flags-to-screenaccesslist.mjs)
// seeded `"compass"` into screenAccessList wherever `compassAccess === true`. The
// legacy boolean is now dead data.
//
// Why `.includes(token)` (strict membership, same rationale as the sibling
// canAccessDashboard / canAccessTimeMachine): the token is either present or it
// isn't — no truthiness coercion — so a future schema change can't accidentally
// open the gate.

export function canAccessCompass(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("compass")
  );
}
